import GeometryType from 'ol/geom/GeometryType';
/*
 * RegEx for matching strings that look like coordinates, lat/long or BNG:
 *
 * 1. Starts with at least one digit which may be prepended by a single '-' character
 * 2. Optionally followed by a decimal point '.' and at least one decimal digit
 * 3. followed by one or more empty space character(s); OR
 *    zero or more empty space characters followed by a comma followed by zero or more
 *    empty space characters
 * 4. As above - at least one digit, optionally prepended with '-',
 * 5. Optionally followed by a decimal point '.' and at least one decimal digit
 */
export const COORDS_PATTERN = /^(-?\d+(\.\d+)?)(\s+|\s*,\s*)(-?\d+(\.\d+)?)$/;

export function resemblesCoords (value) {
    const regex = RegExp(COORDS_PATTERN);
    return regex.test(value);
}

export function isWithinBNGExtent (coords) {
    return (
        coords[0] >= 0 &&
        coords[0] <= 700000 &&
        coords[1] >= 0 &&
        coords[1] <= 1300000
    );
}

export function isNi (epsg) {
    return epsg.endsWith('29903');
}

export function parseGridCoords (value) {
    if (resemblesCoords(value)) {
        const regex = RegExp(COORDS_PATTERN);
        const matches = value.match(regex);
        return [Number(matches[1]), Number(matches[4])];
    }

    return false;
}

export function getEastingNorthingFeature (coords) {
    const isCoordsArrray = Array.isArray(coords);
    const isWithinBNG = isWithinBNGExtent(coords);

    if (!isCoordsArrray || coords.length !== 2 || !isWithinBNG) {
        return undefined;
    }

    return {
        type: 'Feature',
        geometry: {
            type: GeometryType.POINT,
            coordinates: [coords[0], coords[1]]
        },
        properties: {
            displayText: `Easting:${coords[0]} Northing:${coords[1]}`,
            type: 'Easting Northing'
        },
        coordsType: 'bng'
    };
}

export default function getFeatureByEastingNorthings (input) {
    let feature;
    const possibleCoords = resemblesCoords(input);
    if (possibleCoords) {
        const coords = parseGridCoords(input);
        feature = getEastingNorthingFeature(coords);
    }
    return feature;
}
